import { ChangeDetectionStrategy, Component, model, output } from '@angular/core';
import { input } from '@angular/core';

@Component({
    selector: 'ca-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SearchBoxComponent {
    placeholder = input<string>('');
    width = input<string>('auto');
    value = model<string>('');
    clear = output<void>();

    search(value: string) {
        this.value.set(value);
    }

    clearSearch() {
        this.value.set('');
        this.clear.emit();
    }
}
